import React, { useState } from "react";
import { motion } from "framer-motion";

const Films = () => {
  // State untuk mengatur tab mana yang aktif
  const [activeTab, setActiveTab] = useState("watched");

  const movieData = {
    // Kelompok film yang sudah selesai ditonton
    watched: [
      { 
        title: "The Gangster, the Cop, the Devil", 
        year: "2019", 
        genre: "Action", 
        review: "Ma Dong Soek keren abisss, ini film pertama beliau yang aku tonton haha",
        poster: "/posters/thecops.jpg" 
      },
      { 
        title: "Ballerina", 
        year: "2023", 
        genre: "Laga", 
        review: "tanpa cang cing cong langsung dorrr, gapernah sesatisfaying ini nonton orang bales dendam",
        poster: "/posters/ballerina.jpg"
      },
      { 
        title: "Maze Runner", 
        year: "2014", 
        genre: "Fiski Ilmiah/Laga", 
        review: "Gabisa kalau engga dilanjut sampe yang ketiga",
        poster: "/posters/mazerunner.jpg"
      },
      { 
        title: "Kiki's Delievery Services", 
        year: "1989", 
        genre: "Fantasy", 
        review: "Ghibli emang paling cocok kalo mau cari tontonan yang selow tapi mindfull",
        poster: "/posters/kiki.jpg"
      },
      { 
        title: "Your Eyes Tell", 
        year: "2020", 
        genre: "Romance", 
        review: "makasi banget endingnya nangis seneng",
        poster: "/posters/youreyestell.jpg"
      },
      { 
        title: "Grave of the Fireflies", 
        year: "1988", 
        genre: "Perang/Drama", 
        review: "dahlah, jangan tanya akhirnya gimana",
        poster: "/posters/grave.jpg"
      },  
      { 
        title: "Midnight", 
        year: "2021", 
        genre: "Kriminal", 
        review: "hehhhh kata aku mah stop ya Do-shik! greget bangettt",
        poster: "/posters/midnight.jpg"
      },
      {
        title: "Hope", 
        year: "2013", 
        genre: "Kriminal", 
        review: "jahat banget kepala sekolah licik botak itu! menyumpah banget selama nonton gategaaa",
        poster: "/posters/hope.jpg"
      }, 
    ],
    // Kelompok film yang akan segera ditonton
    waitingList: [
      { 
        title: "Spirited Away", 
        year: "2001", 
        genre: "Fantasy", 
        review: "Sering lihat karakternya tapi belum sempett ✨",
        poster: "posters/spiritedaway.jpg" 
      },
      { 
        title: "Ponyo", 
        year: "2008", 
        genre: "Fantasy", 
        review: "pingin nonton semua ghibli ceritanya",
        poster: "posters/ponyo.jpg" 
      },  
      { 
        title: "My Neighbor Totoro", 
        year: "1988", 
        genre: "Fantasy", 
        review: "pingin nonton semua ghibli ceritanya",
        poster: "posters/totoro.jpg" 
      },
      {
        title: "Avatar: Fire & Ash", 
        year: "2025", 
        genre: "Fantasy", 
        review: "rekomendasi ulimaaa, harus tonton 1 dan 2 duluuu",
        poster: "posters/avatar.jpg"
      },    
    ]
  };

  return (
    <motion.div 
      className="category-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <div className="category-header">
        <h2>My Cinematic Journey 🎬</h2>
        
        {/* Menu Tab Minimalis */}
        <div className="tab-menu">
          <button 
            className={activeTab === "watched" ? "active" : ""} 
            onClick={() => setActiveTab("watched")}
          >
            Done & Dusted ({movieData.watched.length})
          </button>
          <button 
            className={activeTab === "waitingList" ? "active" : ""} 
            onClick={() => setActiveTab("waitingList")}
          >
            On My Radar ({movieData.waitingList.length})
          </button>
        </div>
      </div>

      {/* Grid Film dengan Poster */}
      <div className="film-grid">
        {movieData[activeTab].map((film, i) => (
          <motion.div 
            key={i} 
            className="film-card-visual"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.1 }}
            whileHover={{ y: -10 }}
          >
            <div className="poster-wrapper">
              <img src={film.poster} alt={film.title} />
            </div>
            <div className="film-details">
              <h4>{film.title}</h4>
              <span className="film-meta">{film.genre} • {film.year}</span>
              <p className="film-desc">{film.review || film.status}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default Films;